import { render, staticRenderFns } from "./PaymentSettingGeneral.vue?vue&type=template&id=bc591260&scoped=true&"
import script from "./PaymentSettingGeneral.vue?vue&type=script&lang=js&"
export * from "./PaymentSettingGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSettingGeneral.vue?vue&type=style&index=0&id=bc591260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc591260",
  null
  
)

export default component.exports